import { NEUTRAL_HEX } from "app-theme";
const V2_FIELD_DEFAULTS = {
  text_valign: "center",
  text_halign: "center",
  text_size: "12px",
  image: null,
  image_url: null,
  image_fit: 0,
  image_stretch: 1,
  image_valign: "center",
  image_halign: "center"
};
function isLegacyButton(button) {
  return (button.version ?? 1) < 2;
}
function buildCategoryCreate(category, cell, result) {
  return {
    ...V2_FIELD_DEFAULTS,
    text: result.text || category.name,
    background_color: result.backgroundColor,
    type: category.type,
    category_id: category.id,
    product_id: null,
    row_num: cell.row,
    column_num: cell.col,
    version: 2,
    ...imageFields(result)
  };
}
function buildProductCreate(product, cell, result) {
  return {
    ...V2_FIELD_DEFAULTS,
    text: result.text || product.name,
    background_color: result.backgroundColor,
    type: product.category.type,
    category_id: product.category_id,
    product_id: product.id,
    row_num: cell.row,
    column_num: cell.col,
    version: 2,
    ...imageFields(result)
  };
}
function buildEditPatch(button, result) {
  const patch = { ...button, text: result.text, version: 2 };
  patch.background_color = result.backgroundColor;
  if (result.image !== void 0) {
    patch.image = result.image;
    patch.image_url = result.imageUrl ?? null;
  }
  return patch;
}
function categoryToneCascadePatches(products, oldTone, newTone) {
  if (norm(oldTone) === norm(newTone)) return [];
  const isNeutral = (b) => norm(b.background_color ?? "") === norm(NEUTRAL_HEX);
  const effective = (b) => !isLegacyButton(b) && isNeutral(b) ? norm(oldTone) : norm(b.background_color ?? "");
  const allMatch = products.every((b) => effective(b) === norm(oldTone));
  if (allMatch) {
    return products.filter((b) => !isLegacyButton(b) && !isNeutral(b)).map((button) => ({ button, background_color: newTone }));
  }
  return products.filter((b) => !isLegacyButton(b) && isNeutral(b)).map((button) => ({ button, background_color: oldTone }));
}
function norm(hex) {
  return hex.trim().toUpperCase();
}
function hiddenAfterResize(buttons, rows, cols) {
  return buttons.filter((b) => b.row_num > rows || b.column_num > cols).length;
}
function imageFields(result) {
  if (result.image === void 0) return {};
  return { image: result.image, image_url: result.imageUrl ?? null };
}
export {
  V2_FIELD_DEFAULTS,
  buildCategoryCreate,
  buildEditPatch,
  buildProductCreate,
  categoryToneCascadePatches,
  hiddenAfterResize,
  isLegacyButton
};
//# sourceMappingURL=index56.js.map
